
export enum ExceptionSummaryTypeCd {
	ALERT = 'Alert',
	EXCEPTION = 'Exception'}

